//Modules
import React, { useState, useContext } from "react"
//Components
import SEO from "../components/SEO/SEO"
import { StyledContainer } from "../Elements"
//Auth
import firebase from "../auth/firebase"
import { UserContext } from "../context/context"
//Styles
import styled from "styled-components"
import { flex, boxShadow, font, spacing } from "../Utilities"
import { StyledStretchButton } from "../Elements"

const LoginPage = () => {
  const auth = useContext(UserContext)
  const { login } = auth

  const [password, setPassword] = useState("")

  const submitForm = e => {
    e.preventDefault()
    firebase
      .auth()
      .signInWithEmailAndPassword("ms_ty_test@test.com", password)
      .then(res => {
        console.log(res)
        login()
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <>
      <SEO title="Login" description="Login" />
      <StyledContainer>
        <h1>Login</h1>
        <StyledLogin>
          <form onSubmit={submitForm} className="form">
            <label htmlFor="">
              Password
              <input
                type="password"
                value={password}
                onChange={e => {
                  setPassword(e.target.value)
                }}
              />
            </label>

            <StyledStretchButton>Submit</StyledStretchButton>
          </form>
        </StyledLogin>
      </StyledContainer>
    </>
  )
}

const StyledLogin = styled.article`
  ${flex("column", "center", "center")};
  height: 100%;
  width: 100%;

  .form {
    ${flex("column", "center", "center")};
    height: 20rem;
    width: 28rem;
    box-shadow: ${boxShadow.dark};

    label {
      ${flex("column", "center", "center")};
      ${font("SM")};
      margin-bottom: ${spacing.M};

      input {
        margin-top: ${spacing.M};
        ${font("SM")};
      }
    }
  }
`
export default LoginPage
